export const en = {
    'streams-error': 'Failed to receive current broadcasts',
    'upcoming-streams-error': 'Failed to receive scheduled broadcasts',
};
